"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVariableNameDataType = exports.isTsdbDataType = exports.isSlottedDataType = exports.isIndexDataType = void 0;
function isIndexDataType(x) {
    return '__index_data_type' in x;
}
exports.isIndexDataType = isIndexDataType;
function isSlottedDataType(x) {
    return '__slotted_variable_name_data_type' in x;
}
exports.isSlottedDataType = isSlottedDataType;
function isTsdbDataType(x) {
    return '__tsdb_data_type' in x;
}
exports.isTsdbDataType = isTsdbDataType;
function isVariableNameDataType(x) {
    return '__variable_name_data_type' in x;
}
exports.isVariableNameDataType = isVariableNameDataType;
//# sourceMappingURL=filters.js.map